module.exports = __webpack_public_path__ + "img/JMMP_Website_Projects_Typefaces_03_JM-02.1c4b6b52.svg";